/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AssessmentDataModel } from '../models/assessment-data-model';
import { WorkItemModel } from '@api/models/work-item-model';
import { EmployeeModel } from '@api/models/employee-model';
import { InquiryModel } from '../models/inquiry-model';
import { ProcessResponse } from '@api/models/process-response';

@Injectable({
  providedIn: 'root',
})
export class WorkingQueueService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }


  static readonly ApiWorkingQueueGetPath = '/api/WorkingQueue';

/**
   * Retrieves all the WorkItems for a Case.
   */
  apiCaseParentCaseKeyWorkItemsGet$Json$Response(params: {
    parentCaseKey: number;

  }): Observable<StrictHttpResponse<Array<WorkItemModel>>> {

    const rb = new RequestBuilder(this.rootUrl, WorkingQueueService.ApiWorkingQueueGetPath, 'get');
    if (params) {

      rb.path('parentCaseKey', params.parentCaseKey, {});

    }
    return this.http.request(rb.build({
     responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkItemModel>>;
      })
    );
  }

  
  /**
   * Retrieves all the WorkItems for a Case.
   */
  apiCaseParentCaseKeyWorkItemsGet$Json(params: {
    parentCaseKey: number;

  }): Observable<Array<WorkItemModel>> {

    return this.apiCaseParentCaseKeyWorkItemsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<WorkItemModel>>) => r.body as Array<WorkItemModel>)
    );
  }

  
    /**
     * Path part for operation apiWorkItemWorkItemKeyGet
     */
    static readonly ApiWorkItemWorkItemKeyGetPath = '/api/case/WorkItem/{WorkItemKey}';
  
    /**
     * Get a single WorkItem by key.
     *
     */
    apiWorkItemWorkItemKeyGet$Json$Response(params: {
      WorkItemKey: number;
  
    }): Observable<StrictHttpResponse<WorkItemModel>> {
  
      const rb = new RequestBuilder(this.rootUrl, WorkingQueueService.ApiWorkItemWorkItemKeyGetPath, 'get');
      if (params) {
  
        rb.path('WorkItemKey', params.WorkItemKey, {});
  
      }
      return this.http.request(rb.build({
        responseType: 'json',
        accept: 'text/json'
      })).pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<WorkItemModel>;
        })
      );
    }
  
    /**
     * Get a single WorkItem by key.
     *
     *
     *
     * This method provides access to only to the response body.
     * To access the full response (for headers, for example), `apiWorkItemWorkItemKeyGet$Json$Response()` instead.
     *
     * This method doesn't expect any request body.
     */
    apiWorkItemWorkItemKeyGet$Json(params: {
      WorkItemKey: number;
  
    }): Observable<WorkItemModel> {
  
      return this.apiWorkItemWorkItemKeyGet$Json$Response(params).pipe(
        map((r: StrictHttpResponse<WorkItemModel>) => r.body as WorkItemModel)
      );
    }

  /**
   * Path part for operation apiServiceCentreEmployeesGet
   */
  static readonly ApiServiceCentreEmployeesGetPath = '/api/WorkingQueue/employees';

  /**
   * Get all positions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiServiceCentreEmployeesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiServiceCentreEmployeesGet$Json$Response(params?: {

  }): Observable<StrictHttpResponse<Array<EmployeeModel>>> {

    const rb = new RequestBuilder(this.rootUrl, WorkingQueueService.ApiServiceCentreEmployeesGetPath, 'get');
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EmployeeModel>>;
      })
    );
  }

  /**
   * Get all positions.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiServiceCentreEmployeesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiServiceCentreEmployeesGet$Json(params?: {

  }): Observable<Array<EmployeeModel>> {

    return this.apiServiceCentreEmployeesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<EmployeeModel>>) => r.body as Array<EmployeeModel>)
    );
  } 

      /**
       * Path part for operation apiWorkItemPost
       */
      static readonly ApiWorkItemPostPath = '/api/WorkingQueue';
    
      /**
       * Create or Update an WorkItem record.
       */
      apiWorkItemPost$Json$Response(params?: {
        body?: WorkItemModel
      }): Observable<StrictHttpResponse<ProcessResponse>> {
    
        const rb = new RequestBuilder(this.rootUrl, WorkingQueueService.ApiWorkItemPostPath, 'post');
        if (params) {
          //rb.body(params.body, 'application/*+json');
        }
    
        return this.http.request(rb.build({
          responseType: 'json',
          accept: 'text/json'
        })).pipe(
          filter((r: any) => r instanceof HttpResponse),
          map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<ProcessResponse>;
          })
        );
      }
    
      /**
       * Create or Update an WorkItem record.
       */
      apiWorkItemPost$Json(params?: {
        body?: WorkItemModel
      }): Observable<ProcessResponse> {
    
        return this.apiWorkItemPost$Json$Response(params).pipe(
          map((r: StrictHttpResponse<ProcessResponse>) => r.body as ProcessResponse)
        );
      }
    
}
